export const FREE_TRIAL_URLS = ['/free-trial/retail-offer/'];
